import { Box, Button, Typography } from "@mui/material";
import React from "react";
import style from "../RegListActionCard.module.css";
import { useSearchParams } from "react-router-dom";
import { sendReminder } from "../../../../state/workshopSlice";
import { useDispatch } from "react-redux";
import { DateTime } from "luxon";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const RemindRegisteredUsers = ({ workshop, show }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams({});

  const sendReminderClicked = () => {
    dispatch(sendReminder(workshop.workshopId));
  };

  return (
    <Box className={`${style.container} ${!show && style.hidden}`}>
      <Typography variant="h5">Send a reminder</Typography>
      <Box className={style.section} sx={{ paddingBottom: "0.5rem" }}>
        <Typography variant="body1">
          Are you sure you want to send a reminder about this workshop?
        </Typography>
        <Typography variant="body1">
          {workshop?.registrations?.length} people are registered and will
          receive this reminder.
        </Typography>
        {workshop?.reminderSent && (
          <Box
            sx={{
              padding: "0.5rem",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              <NotificationsActiveIcon fontSize="inherit" /> A reminder was sent{" "}
              {DateTime.fromISO(workshop.reminderSent).toLocaleString(
                DateTime.DATETIME_MED
              )}
            </Typography>
          </Box>
        )}
      </Box>
      <Box sx={{ display: "flex", gap: "0.25rem" }}>
        <Button
          variant="contained"
          onClick={sendReminderClicked}
          startIcon={<NotificationsActiveIcon />}
        >
          Send reminder now
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            setSearchParams("");
          }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default RemindRegisteredUsers;
